import type { ButtonProps } from '@launchpad-ui/components';
import { Button } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import styles from './TagAutocomplete.module.css';

interface RemoveAllTagsFooterProps {
  onPress: ButtonProps['onPress'];
}

export function RemoveAllTagsFooter({ onPress }: RemoveAllTagsFooterProps) {
  return (
    <div className={styles.footerContainer}>
      <Button variant="minimal" size="small" onPress={onPress} className={styles.actionButton}>
        <Icon name="arrow-undo" size="small" />
        Remove all tags
      </Button>
    </div>
  );
}
